<template>
  <div class="editor">
    <el-form class="query-container" size="small" inline>
      <el-form-item>
        <el-date-picker v-model="params.startDate" type="datetime" format="yyyy-MM-dd" style="width: 200px"
          placeholder="起始时间"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="params.endDate" type="datetime" format="yyyy-MM-dd" style="width: 200px"
          placeholder="截止时间"></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-select v-model="params.templateId" placeholder="模板" clearable filterable style="width: 220px">
          <el-option v-for="item in templateOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-select v-model="params.emergency" placeholder="紧急程度" clearable style="width: 150px">
          <el-option v-for="item in emergencyObjs" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-select v-model="params.needConfirm" placeholder="是否需要确认" clearable style="width: 150px">
          <el-option v-for="item in needConfirmObjs" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-input v-model="params.driverNo" placeholder="司机编号" clearable style="width: 150px"></el-input>
      </el-form-item>

      <el-form-item>
        <el-select v-model="params.sendBy" placeholder="发送人" clearable filterable style="width: 150px">
          <el-option v-for="u in adminOptions" :key="u.id" :label="formatAdminLabel(u)" :value="u.id" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button @click="query" type="primary">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="notices" style="width: 100%">
      <el-table-column type="index" label="序号" width="50"> </el-table-column>
      <el-table-column prop="emergencyName" label="重要性" width="120"> </el-table-column>
      <el-table-column prop="receiverObj" label="发送对象" width="200"> </el-table-column>
      <el-table-column prop="title" label="主标题" width="150"> </el-table-column>
      <el-table-column prop="subTitle" label="副标题" width="150"> </el-table-column>
      <el-table-column prop="readObj" label="已读" width="120"> </el-table-column>
      <el-table-column prop="submitObj" label="已确认" width="120"> </el-table-column>
      <el-table-column prop="sendByName" label="发送人" width="120"> </el-table-column>
      <el-table-column prop="sendTime" label="发送时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="280">
        <template slot-scope="scope">
          <el-button @click="showNoticeInfo(scope.row)" type="text" size="small">详情</el-button>
          <el-button v-if="scope.row.readNum" @click="viewNotice(scope.row)" type="text" size="small">数据</el-button>
          <el-button type="text" size="small">
            <attachment-adder attachmentType="NOTICE" :bizId="scope.row.id">
              添加业务附件
            </attachment-adder>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="page.pageNo" :page-sizes="pageSizes" :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="page.total" @size-change="onPageSizeChange"
      @current-change="onPageNoChange" />

    <el-dialog :visible.sync="showDetailDialog" title="消息详情">
      <div class="main">
        <div class="title row">{{ noticeInfo.emergencyName }}通知</div>
        <div class="row">
          <span class="label">标题：</span>
          <span class="content">{{ noticeInfo.title }}</span>
        </div>
        <div class="row">
          <span class="label">副标题：</span>
          <span class="content">{{ noticeInfo.subTitle }}</span>
        </div>
        <div class="row">
          <span class="label">内容：</span>
          <span class="content" v-html="noticeInfo.content"></span>
        </div>
        <div v-for="field in noticeInfo.fields" :key="field.id" class="row">
          <span class="label"></span>
          <span class="content">
            <template v-if="field.type == 'img'">
              <el-image v-for="(url, idx) in mediaUrls(field.value)" :key="url + idx" :src="url"
                :preview-src-list="mediaUrls(field.value)"
                style="width: 120px; height: 90px; margin-right: 8px"></el-image>
            </template>
            <template v-if="field.type == 'vedio' || field.type == 'video'">
              <video v-for="(url, idx) in mediaUrls(field.value)" :key="url + idx" :src="url" controls
                style="width: 178px; margin-right: 8px"></video>
            </template>
            <template v-if="field.type == 'audio' || field.type == 'voice'">
              <audio v-for="(url, idx) in mediaUrls(field.value)" :key="url + idx" :src="url" controls></audio>
            </template>
            <template v-if="field.type == 'map'">
              <div :id="field.id" style="width: 100%; height: 148px">
                <img src="../../../assets/image/map.png" style="width: 100%" />
              </div>
            </template>
            <template v-if="field.type == 'link'">
              {{ field.tip }}<el-link type="primary">{{ field.name }}</el-link>
            </template>
            <template v-if="field.type == 'input'">
              <div>{{ field.name }}</div>
              <el-input type="textarea" style="border-radius: 0px" :readonly="true" :placeholder="field.tip"></el-input>
              <el-button style="width: 100%; border-radius: 0px; border-top: 0px">{{
                field.btnName
              }}</el-button>
            </template>
          </span>
        </div>
        <div class="row btns">
          <el-button v-for="btn in noticeInfo.btns" :key="btn.id">{{ btn.name }}</el-button>
        </div>
      </div>

      <div class="footer">
        <el-button @click="showDetailDialog = false" type="primary">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showDataDialog" title="数据详情" :width="dataDialogWidth" top="8vh" append-to-body
      destroy-on-close @opened="layoutDataTable">
      <div class="data-summary">
        <span v-if="noticeInfo.title">{{ noticeInfo.title }}</span>
        <span>发送人：{{ noticeInfo.sendByName || "-" }}</span>
        <span>发送时间：{{ formatDateTime(noticeInfo.sendTime) || "-" }}</span>
      </div>
      <div class="data-summary">
        <span>通知人数：{{ noticeInfo.receiverNum || 0 }}</span>
        <span>查看人数：{{ noticeInfo.readNum || 0 }}</span>
        <span>确认人数：{{ noticeInfo.confirmNum || 0 }}</span>
      </div>

      <el-table ref="dataTable" :data="noticeInfo.details || []" size="small" max-height="420" v-loading="dataLoading">
        <el-table-column type="index" label="序号" width="56" align="center"> </el-table-column>
        <el-table-column prop="driverNo" label="司机编号" width="96" align="center"> </el-table-column>
        <el-table-column prop="teamName" label="车队" min-width="100" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="seat" label="车型" width="64" align="center"> </el-table-column>
        <el-table-column label="是否阅读" width="88" align="center">
          <template slot-scope="scope">{{ scope.row.readed ? "是" : "否" }}</template>
        </el-table-column>
        <el-table-column label="阅读时间" width="168">
          <template slot-scope="scope">{{ formatDateTime(scope.row.readTime) }}</template>
        </el-table-column>
        <el-table-column v-if="showConfirmCols" label="是否确认" width="88" align="center">
          <template slot-scope="scope">{{ scope.row.confirmed ? "是" : "否" }}</template>
        </el-table-column>
        <el-table-column v-if="showConfirmCols" label="确认时间" width="168">
          <template slot-scope="scope">{{ formatDateTime(scope.row.confirmTime) }}</template>
        </el-table-column>
        <el-table-column v-if="showBtnCol" prop="btnValue" label="按钮" min-width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column v-if="showInputCol" prop="inputText" label="输入值" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" width="72" align="center">
          <template slot-scope="scope">
            <el-button @click="gotoDriverInfo(scope.row)" type="text" size="small">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="showDataDialog = false" type="primary" size="small">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { DateUtil } from "@/util/index";
import { getNoticeSendingRecordReadDetails } from "@/api/notice";
import { getAdminList } from "@/api/admin";
export default {
  name: "NoticeSendRecord",
  props: {
    templateFilter: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      params: {},
      adminOptions: [],
      templateOptions: [],
      noticeTypeEnums: [],
      emergencyObjs: [],
      needConfirmObjs: [
        { value: "0", label: "否" },
        { value: "1", label: "是" }
      ],
      pageSizes: [10, 30, 50],
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      notices: [],
      noticeInfo: { templateObj: {} },
      showDetailDialog: false,
      showDataDialog: false,
      dataLoading: false
    };
  },
  computed: {
    showConfirmCols() {
      const info = this.noticeInfo || {};
      if (info.needConfirm || info.confirmNum) {
        return true;
      }
      return (info.details || []).some((item) => item.confirmed || item.confirmTime);
    },
    showBtnCol() {
      return (this.noticeInfo.details || []).some((item) => item.btnValue);
    },
    showInputCol() {
      return (this.noticeInfo.details || []).some((item) => item.inputText);
    },
    dataDialogWidth() {
      let width = 56 + 96 + 120 + 64 + 88 + 168 + 72 + 48;
      if (this.showConfirmCols) {
        width += 88 + 168;
      }
      if (this.showBtnCol) {
        width += 120;
      }
      if (this.showInputCol) {
        width += 140;
      }
      return Math.min(Math.max(width, 680), 1080) + "px";
    }
  },
  watch: {
    templateFilter(val) {
      this.applyTemplateFilter(val);
      this.page.pageNo = 1;
      this.initPage();
    }
  },
  mounted() {
    this.initData();
    this.applyTemplateFilter(this.templateFilter);
    this.query();
  },
  methods: {
    mediaUrls(value) {
      if (Array.isArray(value)) {
        return value.filter((item) => item);
      }
      if (typeof value === "string" && value) {
        return [value];
      }
      return [];
    },
    initData() {
      this.emergencyObjs = window.emergencyObjs;
      this.noticeTypes = window.noticeTypes;
      this.loadAdminList();
      this.loadTemplateOptions();
    },
    applyTemplateFilter(val) {
      this.$set(this.params, "templateId", val && val.id ? val.id : "");
    },
    loadTemplateOptions() {
      this.$http.post("/admin/notice/listtemplate", { _hideLoading: true }).then((res) => {
        this.templateOptions = res.data || [];
      });
    },
    formatAdminLabel(u) {
      return `${u.name || ""}`;
    },
    loadAdminList() {
      const param = {
        page: { size: 500 },
        param: { normalUser: true }
      };
      getAdminList(param).then((res) => {
        const list = res.data.records || [];
        list.unshift({ id: -1, name: "系统" });
        this.adminOptions = list;
      });
    },
    query() {
      this.page.pageNo = 1;
      this.initPage();
    },
    initPage() {
      let params = {};
      Object.assign(params, this.params, this.page);
      if (!params.templateId) {
        delete params.templateId;
      }
      if (params.startDate) {
        params.startDate = DateUtil.format(params.startDate, "yyyy-MM-dd");
      }
      if (params.endDate) {
        params.endDate = DateUtil.format(params.endDate, "yyyy-MM-dd");
      }
      this.$http.post("/admin/notice/queryrecord", params).then((res) => {
        let page = res.data || {};
        this.page.pageNo = page.current;
        this.page.pageSize = page.size;
        this.page.total = page.total;
        this.notices = page.records || [];
        this.notices.forEach((notice) => {
          for (var i = 0; i < this.noticeTypeEnums.length; i++) {
            let noticeType = this.noticeTypeEnums[i];
            if (notice.code == noticeType.code) {
              notice.displayCode = noticeType["displayName"];
            }
          }
          for (var j = 0; j < this.emergencyObjs.length; j++) {
            let emergencyObj = this.emergencyObjs[j];
            if (notice.emergency == emergencyObj.value) {
              notice.emergencyName = emergencyObj.label;
            }
          }
          notice.receiverObj = notice.receiverTeam || notice.receiverNo;
          notice.readObj = notice.readNum + "/" + notice.receiverNum;
          notice.submitObj = notice.confirmNum + "/" + notice.receiverNum;
        });
      });
    },
    onPageSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.initPage();
    },
    onPageNoChange(pageNo) {
      this.page.pageNo = pageNo;
      this.initPage();
    },
    viewNotice(notice) {
      this.noticeInfo = notice;
      if (!notice.templateObj) {
        this.$set(notice, "templateObj", {});
      }
      this.showDataDialog = true;
      if (notice.details) {
        this.dataLoading = false;
        this.$nextTick(() => this.layoutDataTable());
        return;
      }
      this.dataLoading = true;
      const recordId = notice.id;
      getNoticeSendingRecordReadDetails(recordId)
        .then((res) => {
          const data = res.data || {};
          this.$set(notice, "templateObj", data.template || {});
          this.$set(notice, "details", data.details || []);
          if (this.noticeInfo && this.noticeInfo.id === recordId) {
            this.dataLoading = false;
            this.$nextTick(() => this.layoutDataTable());
          }
        })
        .catch(() => {
          if (this.noticeInfo && this.noticeInfo.id === recordId) {
            this.dataLoading = false;
          }
        });
    },
    layoutDataTable() {
      if (this.$refs.dataTable) {
        this.$refs.dataTable.doLayout();
      }
    },
    formatDateTime(value) {
      if (!value) {
        return "";
      }
      if (typeof value === "string") {
        return value.replace("T", " ").substring(0, 19);
      }
      return this.$options.filters.dateFormat(value, "yyyy-MM-dd HH:mm:ss");
    },
    showNoticeInfo(notice) {
      if (notice.templateObj) {
        this.noticeInfo = notice;
        this.showDetailDialog = true;
      } else {
        this.$http.post("/admin/notice/template/" + notice.templateId, {}).then((res) => {
          notice.templateObj = res.data || {};
          this.noticeInfo = notice;
          this.showDetailDialog = true;
        });
      }
    },
    gotoDriverInfo() {
      //TODO
    }
  }
};
</script>

<style lang="less" scoped>
.query-container {
  padding-bottom: 12px;
}

.row {
  margin: 10px 0;

  .label {
    display: inline-block;
    width: 72px;
  }

  .content {
    display: inline-block;
  }
}

.btns.row {
  margin-top: 50px;
}

.title {
  margin-bottom: 40px;
  font-weight: 600;
}

.footer {
  text-align: right;
  margin-top: 10px;
}

.data-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 20px;
  margin-bottom: 8px;
  line-height: 22px;
  color: #606266;
}
</style>
